import { render, staticRenderFns } from "./pgcategory.vue?vue&type=template&id=3789562c&"
import script from "./pgcategory.vue?vue&type=script&lang=js&"
export * from "./pgcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports